import { InjectionToken } from '@angular/core';
import { ReportColumn } from '../report/report-column.types';

export const REPORT_COLUMNS = new InjectionToken<ReportColumn[]>(
  'REPORT_COLUMNS',
);
